import { createSimpleLifecycle } from "./lifecycle";
export function onDidMount(callback) {
    return createSimpleLifecycle("componentDidMountCallback", callback);
}
export default onDidMount;

//# sourceMappingURL=onDidMount.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/onDidMount.js
// module id = 51
// module chunks = 0